import React from 'react';

import { END_OR_START, FEEDBACKS_FROM } from '@src/constants';

import { Star } from '@src/assets/icons/star';

import moment from 'moment';
import 'moment/locale/ru';

import { ArrowLeft } from '@src/assets/icons/arrowLeft';

// @ts-expect-error
import { debounce } from 'lodash/lodash';

// @ts-expect-error
import Slider from 'react-slick';

import styles from './servicesFeedbacks.module.scss';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import '@src/styles/landingProducts.scss';

const feedbackArr = [
  {
    name: 'Леонид',
    date: '09.04.2025',
    rating: 5,
    description: `Нормальнoe местo, взять можнo вce относительнo недорогo, т. К. 
    Нe будет никакиx левыx списаний c карты, тo есть можнo будет вce взять зa 10-15 минут, 
    займы реальнo быстpo выдаются безo всякиx задержек. Ну и требования пo документам низкиe, 
    нужнa толькo фотография паспортa.`,
    from: FEEDBACKS_FROM.SRAVNI,
  },
  {
    name: 'Олег',
    date: '08.04.2025',
    rating: 5,
    description: `Oфopмлeниe зaймa быcтpoe. Никaкиx лишниx звoнкoв. Дeньги нa кapту пpиxoдят мoмeнтaльнo. 
    Пpoцeнт тoжe впoлнe приемлемый. Они сделали не ежедневный процент как ранее, 
    а как в банке - помесячный график платежей. У мeня тoлькo пoлoжитeльные впечатления. 
    Глaвнoe вoзвpaщaть дeньги вoвpeмя.`,
    from: FEEDBACKS_FROM.BANKI_RU,
  },
  {
    name: 'Константин',
    date: '01.04.2025',
    rating: 5,
    description: `Мне понравились в целом условия по займу. Воспользовался тарифом «до зарплаты», 
    одолжив на месяц 15 тыс. Также отмечу, что в договоре отсутствуют дополнительные услуги, что не может не радовать.`,
    from: FEEDBACKS_FROM.VIBERU,
  },
  {
    name: 'Савва',
    date: '23.03.2025',
    rating: 5,
    description: `Почитал кучу информации о рефинансировании, и, честно говоря, не ожидал, 
    что процесс будет таким простым. Я обращался в разные микрофинансовые организации, но «Бюджет» меня удивил. 
    По тарифу «стандартный» получил деньги под 12% в месяц, погасил все свои долги. 
    Заявку одобрили минут за 40, быстро, четко и не дорого вышло.`,
    from: FEEDBACKS_FROM.SRAVNI,
  },
  {
    name: 'Виталий',
    date: '14.03.2025',
    rating: 5,
    description: `Время от времени мне приходится обращаться к услугам этой компании, и я остаюсь доволен. 
    Особенно впечатляют прозрачные условия и лояльное отношение к клиентам. 
    В сложных ситуациях всегда можно рассчитывать на помощь и понимание.`,
    from: FEEDBACKS_FROM.VIBERU,
  },
  {
    name: 'Анастасия',
    date: '07.03.2025',
    rating: 5,
    description: `Пользовалась услугой через сайт проблем ни каких не встретила, 
    после досрочного погашения первого займа, повысили лимит на получение второго! 
    Процент также уменьшился и стал 11% в месяц. Поддержка на связи в любое время, взятие и погашение быстрое. 
    Рекомендую компанию всем, кому нужны деньги на короткий срок и под адекватный процент.`,
    from: FEEDBACKS_FROM.BANKI_RU,
  },
  {
    name: 'Петр',
    date: '03.03.2025',
    rating: 5,
    description: `Перенес все свои долги перед другими мфо в эту компанию, рефинансировав займы. 
    Процент 12 в месяц, тариф взял на пол года стандартный, надеюсь, что за это время погашу без проблем кредит. 
    Условия приемлемые, по крайней мере процент ниже, чем был ранее. Также понравилось, 
    что нет в договоре никаких иных платежей или комиссий, все честно.`,
    from: FEEDBACKS_FROM.SRAVNI,
  },
  {
    name: 'Артем',
    date: '26.02.2025',
    rating: 5,
    description: `Я работаю на машине, тут случилась поломка, а деньги я отправил родным, взял займ на пару дней, 
    процент далеко не приятный, но для получения денег нужен только паспорт, поддержка ответила минут за 30, 
    никаких других услуг и тп, в общем быстро и базово. Помогли.`,
    from: FEEDBACKS_FROM.BANKI_RU,
  },
  {
    name: 'Анатолий',
    date: '20.02.2025',
    rating: 5,
    description: `Этo дaлeкo нe eдинcтвeннaя MФO, кoтopoй я пoльзуюcь, нo здecь ocнoвнoe пpeимущecтвo - 
    этo пpocтoтa пoлучeния зaймa, тo ecть ничeгo cлoжнoгo в тoм чтoбы eгo пoлучить дeйcтвитeльнo нeт, 
    кoпия пacпopтa и иформация о месте работы. Oбычнo зa 20 минут нe тoлькo peшeниe пpиxoдит, нo и дeньги ужe.`,
    from: FEEDBACKS_FROM.VIBERU,
  },
  {
    name: 'Сабрина',
    date: '15.02.2025',
    rating: 5,
    description: `Искала где выгоднее одолжить, а также варианты без справок о доходах и без навязывания страховок 
    и прочей ерунды. Эта компания предложила займ по тарифу "до зарплаты" под относительно невысокий процент, 
    анкету заполнила и в течение часа примерно получила деньги на карту. Сегодня был погашен долг, все честно, 
    никаких подводных камней.`,
    from: FEEDBACKS_FROM.BANKI_RU,
  },
  {
    name: 'Инна',
    date: '11.02.2025',
    rating: 5,
    description: `Захотела приобрести новое спортивное оборудование в спортзал да и себе домой не лишним будет 
    для спортзала не рассчитала и не хватило. МФО «Бюджет» помогла мне с займом, который я получила за 45 минут. 
    Процентная ставка по тарифу «до зарплаты» составила 0,4% В день. Хорошие сотрудники.`,
    from: FEEDBACKS_FROM.VIBERU,
  },
  {
    name: 'Роман',
    date: '21.01.2025',
    rating: 5,
    description: `Мне была нужна финансовая поддержка и данная организация сильно помогла мне. Да, 
    процент выше чем в банке, взял ставку 0.2 процента в день, но зато для получения средств требуется только паспорт. 
    Проконсультировали меня хорошо, всё было понятно, в общем сервис выполняет свои функции хорошо и быстро.`,
    from: FEEDBACKS_FROM.SRAVNI,
  },
  {
    name: 'Ефим',
    date: '06.01.2025',
    rating: 5,
    description: `Хорошая компания с адекватными условиями на свои услуги. Обращаюсь не часто, но всегда знаю, 
    что проблем не будет. Одобряют быстро, сама процедура стандартная - подаешь заявку, ждешь рассмотрения 
    и получаешь свои деньги. Ничего лишнего.`,
    from: FEEDBACKS_FROM.BANKI_RU,
  },
  {
    name: 'Павел',
    date: '29.12.2024',
    rating: 5,
    description: `Люблю посидеть за играми и старое кресло уже не подходит мне и нужно было купить новое эргономичное 
    кресло для домашнего кабинета Бюджет одобрили займ под 12% в месяц по тарифу стандарт.`,
    from: FEEDBACKS_FROM.VIBERU,
  },
  {
    name: 'Светлана',
    date: '16.12.2024',
    rating: 5,
    description: `Понравилось, что в долг выдают онлайн. Оформила займ на сумму в 15 000 рублей по тарифу «до зарплаты», 
    переплата 0.2 в день. Это не бьет по карману, отдала долг через неделю. Заявка оформляется просто, 
    ждала с пол часика, потом сразу же перечислили на карту Мир деньги. Для меня это вполне удобный способ одолжить.`,
    from: FEEDBACKS_FROM.SRAVNI,
  },
];

const sliderOptions = {
  dots: false,
  arrows: false,
  centerMode: true,
  infinite: false,
  centerPadding: `0vw`,
  slidesToShow: 1,
  variableWidth: true,
  speed: 400,
  initialSlide: 0,
};

interface IFeedBackItemProps {
  item: (typeof feedbackArr)[0];
  className: string;
}

const FeedBackItem = ({ item, className }: IFeedBackItemProps) => (
  <div className={className}>
    <div className={styles.upBlock}>
      <div className={styles.starsBlock}>
        {new Array(5).fill(null).map((_, childI) => (
          <Star
            // eslint-disable-next-line react/no-array-index-key
            key={childI}
            width={18}
            height={16}
            stroke="#F82E3A"
            fill={item.rating > childI ? '#F82E3A' : 'none'}
          />
        ))}
      </div>
      <p className={styles.date}>
        {moment(item.date, 'DD.MM.YYYY').locale('ru').format('D MMMM YYYY')}
      </p>
    </div>
    <p className={styles.name}>{item.name}</p>
    <p className={styles.description}>{item.description}</p>
    <img
      className={styles.fromImg}
      src={`/img/feedbacks/${item.from}.webp`}
      alt={item.from}
    />
  </div>
);

export const ServicesFeedbacks = () => {
  const scrollRef = React.useRef<HTMLDivElement>(null);
  const [isEndOrStart, setIsEndOrStart] = React.useState<END_OR_START | ''>(
    END_OR_START.START
  );

  const scroll = debounce((direction: 'left' | 'right') => {
    const isLeft = direction === 'left';
    const count = isLeft ? -298 : 298;
    const currentRef = scrollRef.current;
    if (currentRef) {
      currentRef.scrollBy({
        left: count,
        behavior: 'smooth',
      });
      const currentPosition = currentRef.scrollLeft + count;
      const atStart = currentPosition <= 0;
      const atEnd =
        currentPosition + currentRef.clientWidth >= currentRef.scrollWidth;

      setIsEndOrStart(
        atStart ? END_OR_START.START : atEnd ? END_OR_START.END : ''
      );
    }
  }, 300);

  return (
    <div className={styles.container}>
      <p className={styles.commonTitleWithMargin}>Отзывы о сервисе</p>
      <div className={styles.feedBackArrowsBlockDesktop}>
        <div
          className={`${styles.arrowBlock} ${styles.arrowBlockLeft} ${
            isEndOrStart === END_OR_START.START
              ? styles.arrowBlockNoActive
              : styles.arrowBlockActive
          }`}
          onClick={() => scroll('left')}
        >
          <ArrowLeft width={22} height={16} fill="#000" />
        </div>
        <div
          className={`${styles.arrowBlock} ${styles.arrowBlockRight} ${
            isEndOrStart === END_OR_START.END
              ? styles.arrowBlockNoActive
              : styles.arrowBlockActive
          }`}
          onClick={() => scroll('right')}
        >
          <ArrowLeft
            width={22}
            height={16}
            fill="#000"
            className={styles.arrowRight}
          />
        </div>
        <div className={styles.feedBacksBlock} ref={scrollRef}>
          <div className={styles.feedBacksBlockInner}>
            {feedbackArr.map((el, i) => (
              // eslint-disable-next-line react/no-array-index-key
              <FeedBackItem key={i} item={el} className={styles.feedBackItem} />
            ))}
          </div>
        </div>
      </div>
      <div className={styles.feedBackMobile}>
        <Slider {...sliderOptions} className="component-products__carousel">
          {feedbackArr.map((el, regIndex) => (
            <FeedBackItem
              // eslint-disable-next-line react/no-array-index-key
              key={regIndex}
              item={el}
              className={`component-products__carousel__item ${styles.feedBackItemMobile}`}
            />
          ))}
        </Slider>
      </div>
    </div>
  );
};
